import React from "react";
import { Tooltip, Text } from "@chakra-ui/react";

const TruncatedTextWithTooltip = ({ text, maxChars = 20, className = "", fontSize, placement="top", showTooltip = true, style = {} }) => {
  const isTruncated = text?.length > maxChars;
  const displayedText = isTruncated ? text?.slice(0, maxChars) + "..." : text;

  // If showTooltip is false or text is not truncated, don't show tooltip
  const shouldShowTooltip = showTooltip && isTruncated;

  return (
    <Tooltip 
      usePortal={true} 
      zIndex="modal" 
      placement={placement} 
      label={text} 
      isDisabled={!shouldShowTooltip} 
      hasArrow
    >
      <Text
        // as="span"
        modifiers={[{ name: 'zIndex', options: { zIndex: 999999 } }]}
        className={className}
        cursor="default"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        fontSize={fontSize}
        style={{ lineHeight: "2", ...style }}
      >
        {displayedText}
      </Text>
    </Tooltip>
  );
};

export default TruncatedTextWithTooltip;
